const siteUrl = import.meta.env.VITE_SITE_URL || "https://hipobuyspread.sbs";
const logoUrl = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg";

export const homepageSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Hipobuy Spreadsheet Hub",
  url: siteUrl,
  description:
    "The ultimate shopping spreadsheet resource center. Discover organized product lists, compare shopping spreadsheets, and find products faster with expert guides designed for smart shoppers.",
  inLanguage: "en",
  publisher: {
    "@type": "Organization",
    name: "Hipobuy Spreadsheet Hub",
    logo: {
      "@type": "ImageObject",
      url: logoUrl,
    },
  },
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline: "What Is Hipobuy Sheet? Complete Beginner's Guide 2026",
  description:
    "Everything you need to know about Hipobuy Spreadsheet — how it works, why thousands of shoppers rely on it daily, and how you can get started with organized product discovery today.",
  image:
    "https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20with%20laptop%20showing%20organized%20spreadsheet%20on%20screen%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20desk%20setup%2C%20professional%20aesthetic%2C%20simple%20elegant%20composition%2C%20productivity%20theme&width=1200&height=600&seq=article-hero-guide&orientation=landscape",
  author: {
    "@type": "Organization",
    name: "Hipobuy Spreadsheet Hub",
  },
  datePublished: "2026-07-01",
  dateModified: "2026-07-09",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": `${siteUrl}/hipobuy-spreadsheet-guide`,
  },
  publisher: {
    "@type": "Organization",
    name: "Hipobuy Spreadsheet Hub",
    logo: {
      "@type": "ImageObject",
      url: logoUrl,
    },
  },
};

export const articleFAQSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What is Hipobuy Spreadsheet?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Hipobuy Spreadsheet is an organized product discovery system that helps shoppers browse products across 14 curated categories. It replaces manual searching with structured, categorized product listings for faster and more efficient shopping research.",
      },
    },
    {
      "@type": "Question",
      name: "Is Hipobuy Sheet free to use?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, accessing and browsing Hipobuy Spreadsheet categories is completely free. You can explore all 14 product categories without any cost or subscription requirement.",
      },
    },
    {
      "@type": "Question",
      name: "How is Hipobuy Sheet different from Kakobuy Spreadsheet?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "While both platforms serve similar purposes, Hipobuy Sheet offers broader category coverage with 14 categories and emphasizes beginner-friendliness. Kakobuy Spreadsheet tends to focus more specifically on fashion products.",
      },
    },
    {
      "@type": "Question",
      name: "Is Hipobuy Spreadsheet safe?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Hipobuy Spreadsheet serves as a product discovery and organization tool. The safety of individual product purchases depends on the specific merchants and platforms you ultimately buy from. Always exercise standard online shopping caution.",
      },
    },
    {
      "@type": "Question",
      name: "How often is the Hipobuy Sheet updated?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The spreadsheet is updated regularly with new product additions and refreshed listings. For the most current information, we recommend checking back frequently or visiting the main store at kaspreadsheet.com.",
      },
    },
    {
      "@type": "Question",
      name: "Can beginners use Hipobuy Spreadsheet?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Absolutely. Hipobuy Sheet is designed to be beginner-friendly with intuitive category navigation, clear product organization, and simple browsing mechanics. Most new users feel comfortable within minutes of their first visit.",
      },
    },
  ],
};